import { Controller } from "@hotwired/stimulus"
import { show_toast } from "../toasts"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = [ "source" ];

  connect() {
  }

  copy(ev) {
    navigator.clipboard.writeText(this.sourceTarget.value);
    show_toast("Project link copied to clipboard");
    ev.preventDefault();
  }
}
